(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('issue-significance', {
            parent: 'company_admin',
            url: '/issue-significance',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.issueSignificance.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/issue-significance/issue-significances.html',
                    controller: 'IssueSignificanceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('issueSignificance');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('issue-significance-detail', {
            parent: 'company_admin',
            url: '/issue-significance/{id}',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN'],
                pageTitle: 'abcQualityMatchApp.issueSignificance.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/company_admin/issue-significance/issue-significance-detail.html',
                    controller: 'IssueSignificanceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('issueSignificance');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'IssueSignificance', function($stateParams, IssueSignificance) {
                    return IssueSignificance.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'issue-significance',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('issue-significance-detail.edit', {
            parent: 'issue-significance-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/issue-significance/issue-significance-dialog.html',
                    controller: 'IssueSignificanceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IssueSignificance', function(IssueSignificance) {
                            return IssueSignificance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('issue-significance.new', {
            parent: 'issue-significance',
            url: '/new',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/issue-significance/issue-significance-dialog.html',
                    controller: 'IssueSignificanceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                deleted: false,
                                id: null,
                                company:{}
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('issue-significance', null, { reload: 'issue-significance' });
                }, function() {
                    $state.go('issue-significance');
                });
            }]
        })
        .state('issue-significance.edit', {
            parent: 'issue-significance',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/issue-significance/issue-significance-dialog.html',
                    controller: 'IssueSignificanceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IssueSignificance', function(IssueSignificance) {
                            return IssueSignificance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('issue-significance', null, { reload: 'issue-significance' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('issue-significance.delete', {
            parent: 'issue-significance',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_COMPANY_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/company_admin/issue-significance/issue-significance-delete-dialog.html',
                    controller: 'IssueSignificanceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['IssueSignificance', function(IssueSignificance) {
                            return IssueSignificance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('issue-significance', null, { reload: 'issue-significance' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
